<template>
    <div v-if="loading" class="text-center">
        <b-spinner></b-spinner>
    </div>
    <div v-else>
        <validation-observer ref="observer" v-slot="{ passes }">
            <b-form @submit.prevent="passes(saveSettings)">

                <b-form-group id="from_nameFormGroup" label="From Name" label-for="from_nameInput">
                    <validation-provider name="From name" rules="required" v-slot="{ errors }">
                        <b-form-input id="from_nameInput" v-model="channel.from_name"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>
                </b-form-group>

                <b-form-group id="greetingFormGroup" label="Greeting" label-for="greetingInput">
                    <validation-provider name="Greeting" rules="required" v-slot="{ errors }">
                        <b-form-textarea
                            id="greetingInput"
                            v-model="channel.greeting"
                            placeholder="Hi <name>,"
                            maxlength="180"
                        ></b-form-textarea>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>
                </b-form-group>


                <validation-provider name="Business Description" rules="" v-slot="{ errors }">
                    <b-form-group id="businessDescriptionInputGroup" label="Business Description" label-for="businessDescriptionInput">
                        <p>The business description will be used to provide more context to the AI models.</p>
                        <b-form-textarea
                            id="businessDescriptionInput"
                            v-model="channel.business_description"
                            placeholder="Name, is about..."
                            maxlength="250"
                        ></b-form-textarea>
                        <span class="validation">{{ errors[0] }}</span>
                        <p class="small py-0 text-muted">Max 250 chars.</p>
                    </b-form-group>
                </validation-provider>

                <b-form-group id="customerPanelUrlFormGroup" label="Customer Panel URL" label-for="customerPanelUrlInput">
                    <p>Display a panel next to each thread to quickly see key information about the customer.</p>
                    <validation-provider name="Customer Panel URL" rules="url" v-slot="{ errors }">
                        <b-input-group append="customer@example.com">
                            <b-form-input id="customerPanelUrlInput" v-model="channel.customer_panel_url" type="url" placeholder="https://example.com/api/inboxgpt/7dsX?email="></b-form-input>
                        </b-input-group>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>
                    <p class="small py-0 text-muted">You should provide a link to your CRM or customer database. Expected return is a JSON format like: <i>{"data":[{"Key 1":"value 1"},{},{}]}</i></p>
                </b-form-group>


                <b-form-group label="Signature" label-for="signatureTextarea">
                    <validation-provider name="Signature" rules="" v-slot="{ errors }">
                        <vue-editor v-model="channel.signature" id="signatureTextarea" :editor-toolbar="customEditorToolbar"></vue-editor>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>
                </b-form-group>

<!--                <b-form-group label="Knowledgebase" label-for="signatureTextarea">-->
<!--                    <validation-provider name="Knowledgebase" rules="" v-slot="{ errors }">-->
<!--                        <b-textarea v-model="channel.knowledgebase" id="signatureTextarea" placeholder='{text: "example"}'></b-textarea>-->
<!--                        <span class="validation">{{ errors[0] }}</span>-->
<!--                    </validation-provider>-->
<!--                </b-form-group>-->

                <b-button type="submit" variant="primary">Save</b-button>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import {
    VueEditor
} from "vue2-editor";
import NotificationPop
    from "../mixins/NotificationPop";
import ManagePages
    from "./ManagePages";

export default {
    components: { VueEditor },
    mixins: [NotificationPop],
    props: {
        channelId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            customEditorToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
            ],
            channel: {
                signature: '',
                knowledgebase: '',
                from_name: '',
                business_description: '',
                customer_panel_url: ''
            },
            loading: true
        };
    },
    created() {

        // Fetch channels data from API
        this.$http.get(`channels/${this.channelId}`)
            .then(response => {
                // console.log(response.data)
                this.channel = response.data.data;
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                // Hide the loading spinner
                this.loading = false;
            });
    },
    methods: {
        saveSettings() {
            this.$http
                .put(`channels/${this.channelId}`, this.channel)
                .then(response => {
                    this.popNotification('Settings saved successfully', 'success')
                    console.log('Settings saved successfully');
                })
                .catch(error => {
                    this.popNotification('Cannot save settings. Please contact support', 'danger')
                    console.error('Error saving settings', error);
                });
        },
    },
};
</script>

<style scoped>
.b-form-group {
    margin-bottom: 1rem;
}
</style>
